unit UClockEditForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, UMainConfig,
  UEssentialHelper, WEBLib.Buttons, System.DateUtils;

type
  TClockEditForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlData: TPanel;
    WebLabel1: TLabel;
    WebLabel4: TLabel;
    btnStore: TBitBtn;
    dtpDate: TDateTimePicker;
    dtpTime: TDateTimePicker;
    procedure WebFormResize(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure dtpDateChange(Sender: TObject);
    procedure btnStoreClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
  private
    changeEnabled: Boolean;
    FMainConfig: TMainConfig;
    FTimePoint: TDateTime;
    function TruncDateTime(value: TDateTime): TDateTime;
    procedure SetMainConfig(const value: TMainConfig);
    procedure SetTimePoint(const value: TDateTime);
    procedure Warning;
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property TimePoint: TDateTime read FTimePoint write SetTimePoint;
  protected procedure LoadDFMValues; override; end;

var
  ClockEditForm: TClockEditForm;

implementation

{$R *.dfm}
{ TClockEditForm }

procedure TClockEditForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.ModalResult := mrNone;
  Self.Close;
end;

procedure TClockEditForm.btnStoreClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.ModalResult := mrOk;
end;

procedure TClockEditForm.dtpDateChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  changeEnabled := false;
  Self.TimePoint := Self.TruncDateTime(dtpDate.Date + dtpTime.Time);
  changeEnabled := true;
end;

procedure TClockEditForm.SetMainConfig(const value: TMainConfig);
begin
  FMainConfig := value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
end;

procedure TClockEditForm.SetTimePoint(const value: TDateTime);
begin
  if value <> Self.TimePoint then
  begin
    FTimePoint := Self.TruncDateTime(value);
    if Self.TimePoint > now then
    begin
      Self.Warning;
      changeEnabled := true;
      Self.TimePoint := Self.TruncDateTime(now);
    end
    else
    begin
      if changeEnabled then
      begin
        dtpDate.Date := DateOf(Self.TimePoint);
        dtpTime.Time := TimeOf(Self.TimePoint);
      end;
    end;
  end;
end;

function TClockEditForm.TruncDateTime(value: TDateTime): TDateTime;
var
  helper: string;
begin
  helper := FormatDateTime('dd.mm.yyyy hh:nn', value);
  Result := StrToDateTime(helper);
end;

procedure TClockEditForm.Warning;
begin
  MessageDLG('Eine Stempelung in der Zukunft ist nicht erlaubt!',
    mtWarning, [mbOK]);
end;

procedure TClockEditForm.WebFormCreate(Sender: TObject);
begin
  Self.TimePoint := Self.TruncDateTime(now);
  changeEnabled := true;
end;

procedure TClockEditForm.WebFormResize(Sender: TObject);
var
  i: Integer;
begin
  btnBack.Width := 24;
  btnBack.Height := 24;
  btnBack.Top := 4;
  btnBack.Left := 4;
  imgLogo.Width := 74;
  imgLogo.Height := 24;
  imgLogo.Left := pnlHeader.Width - imgLogo.Width - 4;
  imgLogo.Top := 4;
  lblHeader.Font.Size := 10;
  lblHeader.Top := 7;
  lblHeader.Left := btnBack.Left + btnBack.Width + 4;
  lblHeader.Width := pnlHeader.ClientWidth - btnBack.Width - imgLogo.Width - 16;
  pnlHeader.Height := 32;
  lblHeader.Caption := 'Zeitpunkt ändern';
  pnlData.Left := (Self.ClientWidth - pnlData.Width) div 2;
  i := Self.ClientHeight - pnlHeader.Height - pnlData.Height;
  if pnlFooter.Visible then
    i := i - pnlFooter.Height;
  i := i div 2;
  if i < 0 then
    i := 0;
  pnlData.Top := pnlHeader.Height + i;
end;

procedure TClockEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlData := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  btnStore := TBitBtn.Create(Self);
  dtpDate := TDateTimePicker.Create(Self);
  dtpTime := TDateTimePicker.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlData.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  btnStore.BeforeLoadDFMValues;
  dtpDate.BeforeLoadDFMValues;
  dtpTime.BeforeLoadDFMValues;
  try
    Name := 'ClockEditForm';
    Width := 417;
    Height := 355;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 417;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 270;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UClockEditForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 200;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Zeitpunkt '#228'ndern';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UClockEditForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 331;
    pnlFooter.Width := 417;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlData.SetParentComponent(Self);
    pnlData.Name := 'pnlData';
    pnlData.Left := 96;
    pnlData.Top := 116;
    pnlData.Width := 177;
    pnlData.Height := 160;
    pnlData.Caption := 'pnlData';
    pnlData.ChildOrder := 3;
    pnlData.ShowCaption := False;
    WebLabel1.SetParentComponent(pnlData);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 8;
    WebLabel1.Width := 36;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Datum';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(pnlData);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 8;
    WebLabel4.Top := 56;
    WebLabel4.Width := 37;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Uhrzeit';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    btnStore.SetParentComponent(pnlData);
    btnStore.Name := 'btnStore';
    btnStore.Left := 8;
    btnStore.Top := 104;
    btnStore.Width := 160;
    btnStore.Height := 48;
    btnStore.Caption := #196'ndern';
    btnStore.Color := clNone;
    btnStore.Glyph.LoadFromFile('UClockEditForm.pnlData.btnStore.Glyph.png');
    btnStore.GlyphSize := 32;
    btnStore.HeightPercent := 100.000000000000000000;
    btnStore.WidthPercent := 100.000000000000000000;
    SetEvent(btnStore, Self, 'OnClick', 'btnStoreClick');
    dtpDate.SetParentComponent(pnlData);
    dtpDate.Name := 'dtpDate';
    dtpDate.Left := 8;
    dtpDate.Top := 24;
    dtpDate.Width := 161;
    dtpDate.Height := 22;
    dtpDate.BorderStyle := bsSingle;
    dtpDate.ChildOrder := 3;
    dtpDate.Color := clWhite;
    dtpDate.Date := 45630.455980439820000000;
    dtpDate.Role := '';
    dtpDate.Text := '';
    SetEvent(dtpDate, Self, 'OnChange', 'dtpDateChange');
    dtpTime.SetParentComponent(pnlData);
    dtpTime.Name := 'dtpTime';
    dtpTime.Left := 8;
    dtpTime.Top := 72;
    dtpTime.Width := 161;
    dtpTime.Height := 22;
    dtpTime.BorderStyle := bsSingle;
    dtpTime.ChildOrder := 4;
    dtpTime.Color := clWhite;
    dtpTime.Date := 45630.456250000000000000;
    dtpTime.Kind := dtkTime;
    dtpTime.Role := '';
    dtpTime.ShowSeconds := False;
    dtpTime.Text := 'hh:nn';
    SetEvent(dtpTime, Self, 'OnChange', 'dtpDateChange');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlData.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    btnStore.AfterLoadDFMValues;
    dtpDate.AfterLoadDFMValues;
    dtpTime.AfterLoadDFMValues;
  end;
end;

end.
